import { Injectable } from "@angular/core";

/**
 * Predefined key/code pair that unlocks the override, set the same way as the impersonator:
 * localStorage.setItem("validationOverride", "NDL-FORCE-SUBMIT-7X4QK9")
 */
export const VALIDATION_OVERRIDE_KEY = "validationOverride";
export const VALIDATION_OVERRIDE_CODE = "NDL-FORCE-SUBMIT-7X4QK9";

@Injectable({
    providedIn: "root"
})
export class ValidationOverrideService {
    /**
     * True when the stored code matches, which lets the vendor application be submitted
     * and approved while sections are still incomplete.
     */
    isActive(): boolean {
        try {
            return localStorage.getItem(VALIDATION_OVERRIDE_KEY)?.trim() === VALIDATION_OVERRIDE_CODE;
        } catch (error) {
            // localStorage is unavailable (SSR, private browsing)
            return false;
        }
    }
}
